import { SkeletonImage } from './image';
import { SkeletonParagraph } from './paragraph';
import { Skeleton as InnerSkeleton } from './skeleton';
const Skeleton = InnerSkeleton;
Skeleton.Image = SkeletonImage;
Skeleton.Paragraph = SkeletonParagraph;
export default Skeleton;
